import OlMap from "ol/Map";
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";

import ChangelogMode from 'lib/enums/changelogmode';
import Author from 'lib/enums/author';

const maxLog:number = 20;

export function changelog(feature:Feature<Geometry>, changelogMode:ChangelogMode) {
	const url:string = (window.location != window.parent.location)
	? document.referrer
	: document.location.href;
	
	const author:Author = url.includes('/admin') ? Author.Planner : Author.Public;
	const changelog:any[] = JSON.parse(feature.get('changelog') || '[]');
	
	changelog.push({m: changelogMode, a: author, t: new Date().getTime()});
	
	const firstRecord:any = changelog.shift();
	
	if(changelog.length > maxLog) {
		for(let i = 0; i < changelog.length - maxLog; i++) {
			changelog.shift();
		}
	}
	
	changelog.unshift(firstRecord);
	
	feature.set('changelog', JSON.stringify(changelog));
}
